<template>
  <v-container fluid style="amin-height: 100vh; padding:0 6px; margin: 0; max-width: none; ">

    <v-layout row style="amin-height: calc(100vh - 65px);">
      <v-flex d-flexa xs12 sm3 md3 pa-2 style="padding-left: 4px !important;">
        <!-- <v-card color="red">Latest Conditions</v-card> -->
        <v-card color="white" id="conditions-list" style="overflow-x:hidden; overflow-y:auto; max-height:calc(100vh - 230px);">
          <v-card-title>
            <div>
              <h4 class="mb-0">
                CONDITIONS
                <v-icon>pin_drop</v-icon>
              </h4>
              <div style="font-weight: normal; font-size:.9em">Latest conditions added</div>
              <v-list three-line style="overflow: auto">
                <template v-for="(item, index) in latestConditionsPhotosList">
                  <v-list-tile
                    :key="item.id"
                    @click="viewConditionDetails(item)"
                    avatar>
                    <v-list-tile-avatar>
                      <img
                      v-if="item.photos.length"
                      style="border-radius:0"
                      click="activateImageViewer(apiBaseUrl + '/uploads/' + item.photos[0].filename)"
                      :src="apiBaseUrl + '/uploads/thumbs/' + item.photos[0].filename">
                      <v-icon large v-else>insert_photo</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{ item.observation }} -
                        {{ item.location_type }}
                        <span style="color:#bbb; font-size:.86em; font-style: italic">id: {{ item.id }}</span>
                      </v-list-tile-title>
                      <v-list-tile-sub-title v-html="item.createdAt.substr(0,16)"></v-list-tile-sub-title>
                      <v-list-tile-sub-title v-html="item.description"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
              flat
              block
              @click="scrollConditionsToTop"
              color="grey">
              <v-icon>arrow_upward</v-icon> Back to top
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card color="secondary mt-2" style="height:142px;">
          <v-card-title class="pb-2">
            <h4 class="white--text">
              DOWNLOADS
              <v-icon color="white" style="border-bottom: solid 1px #fff">arrow_downward</v-icon>
            </h4>
          </v-card-title>
          <v-layout row wrap>
            <v-flex md6 pa-2>
          <!-- <div class="px-3"> -->
            <v-btn
              @click="downloadConditions"
              title="Download conditions as CSV"
              color="white"
              block
              outline>
              <v-icon>pin_drop</v-icon>
              Conditions
            </v-btn>
            </v-flex>
            <v-flex md6 pa-2>
            <v-btn
              @click="downloadPhotosFiles"
              title="Download photo files - will be large file size!"
              color="white"
              block
              outline>
              <v-icon>photo</v-icon>
              Photos
            </v-btn>
          <!-- </div> -->
            </v-flex>
        </v-layout>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 sm9 md9>
        <v-layout row wrap>
          <v-flex d-flex xs12 sm12 md12 pa-2 style="height: 135px;padding-bottom: 0 !important; padding-left: 0 !important;padding-right: 0 !important;">
            <v-card color="blue-grey lighten-4">
              <v-layout row wrap>
                <v-flex xs2 md2 py-4>
                  <div class="figure">
                    {{ totalUsers }}
                    <v-icon color="#777">people</v-icon>
                  </div>
                  <div class="figure-label">
                    People Registered
                  </div>
                </v-flex>
                <v-flex xs2 md2 py-4>
                  <div class="figure">
                    {{ totalConditions }}
                    <v-icon color="#777">pin_drop</v-icon>
                  </div>
                  <div class="figure-label">
                    Conditions Added
                  </div>
                </v-flex>
                <v-flex xs2 md2 py-4>
                  <div class="figure">
                    {{ totalPhotos || '?' }}
                    <v-icon color="#777">photo</v-icon>
                  </div>
                  <div class="figure-label">
                    Photos Added
                  </div>
                </v-flex>
                <v-flex xs3 md2 style="position:relative">
                  <div
                    v-if="this.statsObservations.barrier"
                    class="chart-container"
                    style="float:left; position: relative; height:90px; width:90px; padding-top: 5px">
                    <pie-chart
                      :data="piechartObservationData"
                      :options="piechartOptions">
                    </pie-chart>
                  </div>
                  <div style="position: absolute; left: 90px; afloat:left; padding-top:43px; text-transform: capitalize">
                    <div
                      v-for="(color, key) in observationsColors"
                      :key="'obs'+key"
                      style="margin-top: 3px; font-size:.9em">
                      <span
                        :style="{
                          border: 'solid 2px #111',
                          display: 'inline-block',
                          width: '12px',
                          height:'12px',
                          'background-color': color
                        }"></span>
                       {{ key }}
                      </div>
                  </div>
                </v-flex>
                <v-flex xs3 md2 style="position:relative">
                  <div
                    v-if="this.statsLocationTypes.point"
                    class="chart-container"
                    style="float:left; position: relative; height:90px; width:90px; padding-top: 5px">
                    <pie-chart
                      :data="piechartLocationTypeData"
                      :options="Object.assign({}, piechartOptions,
                      {
                        title: {
                          display: true,
                          fontSize: 14,
                          fontStyle: '',
                          fontColor: '#333',
                          text:' Location Types'
                        }
                      }
                      )">
                    </pie-chart>
                  </div>
                  <div style="position: absolute; left: 80px; afloat:left; padding-top:43px; text-transform: capitalize">
                    <div
                      v-for="(color, key) in locationTypesColors"
                      :key="'loc'+key"
                      style="margin-top: 3px; font-size:.9em">
                      <span
                        :style="{
                          border: 'solid 2px #111',
                          display: 'inline-block',
                          width: '12px',
                          height:'12px',
                          'background-color': color
                        }"></span>
                       {{ key }}
                      </div>
                  </div>
                </v-flex>
                <v-flex xs3 md2>
                  <!-- <div>Latest activity</div> -->
                  <div style="position: relative; min-height: 100px; width: 100%; margin-top: 5px; padding: 0 15px 5px 15px">
                    <v-sparkline
                      :labels2="timelineLabels"
                      :value="Object.values(timeline)"
                      color="primary"
                      height="150"
                      line-width="2"
                      padding="16"
                    ></v-sparkline>
                    <div
                      :title="`Latest Activity between ${timelineLabels[0]} and ${timelineLabels[1]}`"
                      style="font-size:1em; text-align:center; color:#333; position: absolute; top: 10px;">Latest Activity</div>
                  </div>
                </v-flex>
                <v-flex xs3 md1>
                  <v-btn block>Conditions</v-btn>
                  <v-btn block>Photos</v-btn>
                </v-flex>

              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 pa-2 style="height: calc(100vh - 199px); padding-left: 0 !important;padding-right: 0 !important;">
            <div id="admin-map-key">
              <ul>
              <li><svg height="14" width="14"><circle cx="7" cy="7" r="6" stroke-width="1" stroke="#111" :fill="observationsColors.barrier" /></svg> Barrier</li>
              <li><svg height="14" width="14"><circle cx="7" cy="7" r="6" stroke-width="1" stroke="#111" :fill="observationsColors.strength" /></svg> Strength</li>
              <li><svg height="14" width="14"><circle cx="7" cy="7" r="6" stroke-width="1" stroke="#111" :fill="observationsColors.idea" /></svg> Idea</li>
              </ul>
            </div>
            <v-card color="green" style="" id="admin-map">Map</v-card>
          </v-flex>
        </v-layout>
      </v-flex>

    </v-layout>


   <v-dialog
      v-model="conditionDetailsDialog"
      width="700">
      <v-card v-if="Object.keys(conditionDetailsData).length">
        <v-card-title class="headline primary white--text">
          {{ conditionDetailsData.observation }}
          <v-spacer></v-spacer>
          <v-btn small icon @click="conditionDetailsDialog = false">
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="min-height: 200px;">
          {{ conditionDetailsData.description }}
          <template v-if="conditionDetailsData.photos.length">
            <img
              v-for="img in conditionDetailsData.photos[0].split(',')"
              :src="apiBaseUrl + '/uploads/' + img"
              class="photo-main">
          </template>
        </v-card-text>

      </v-card>
    </v-dialog>


  </v-container>
</template>

<script>
import * as L from 'leaflet'
import PieChart from '../components/PieChart'

const apiBaseUrl = (process.env.NODE_ENV === 'production')
                    ? 'https://api.warnerconnects-audit.org'
                    : 'http://localhost:3030'

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
const observationsColors = {
  barrier: '#e6031a',
  strength: '#00A800',
  idea: '#E3EC34',
}
const locationTypesColors = {
  point: '#5C3DF4',
  intersection: '#5C7DC4',
  corridor: '#492D68'
}

let map, markers = []

export default {
  components: { PieChart },
  data () {
    return {
      lorem: 'gjbbssjgksjgsdgsgd',
      apiBaseUrl: apiBaseUrl,
      errors: {},
      observationsColors,
      locationTypesColors,
      totalUsers: 0,
      totalPhotos: 0,
      conditions: [],
      photos: [],
      conditionsPhotosList: [],
      startLatLng: [34.176571, -118.604794],
      conditionDetailsDialog: false,
      conditionDetailsData: {}
    }
  },
  computed: {
    conditionsPhotosDateAsc () {
      return [...this.conditionsPhotosList].sort((a,b) => (new Date(a.createdAt) - new Date(b.createdAt)))
    },
    conditionsPhotosDateDesc () {
      return [...this.conditionsPhotosList].sort((a,b) => (new Date(b.createdAt) - new Date(a.createdAt)))
    },
    latestConditionsPhotosList () {
      return [...this.conditionsPhotosDateDesc].slice(0,200)  // top 200
    },
    totalConditions () {
      return this.conditionsPhotosList.length
    },
    statsObservations () {
      let results = {}
      for (let i in this.conditionsPhotosList) {
        let observation = this.conditionsPhotosList[i].observation.toLowerCase()
        if (!results[observation]) {
          results[observation] = 1
        }
        results[observation]++
      }
      return results
    },
    statsLocationTypes () {
      let results = {}
      for (let i in this.conditionsPhotosList) {
        let locationType = this.conditionsPhotosList[i].location_type.toLowerCase()
        if (!results[locationType]) {
          results[locationType] = 1
        }
        results[locationType]++
      }
      return results
    },
    piechartOptions () {
      return {
        responsive: true,
        legend: {
          display: false,
          position: 'right',
          align: 'middle'
        },
        layout: {
          padding: 0
        },
        title: {
          display: true,
          fontSize: 14,
          fontStyle: '',
          fontColor: '#333',
          text:' Observations'
        },
        elements: {
          arc: {
            borderColor: '#111'
          }
        }
      };
    },
    piechartObservationData () {
      return {
        labels: ['Barriers', 'Strengths', 'Ideas'],
        datasets: [
          {
            backgroundColor: [this.observationsColors.barrier, this.observationsColors.strength, this.observationsColors.idea],
            data: [parseInt(this.statsObservations.barrier), parseInt(this.statsObservations.strength), parseInt(this.statsObservations.idea)],
          }
        ]
      };
    },
    piechartLocationTypeData () {
      return {
        labels: ['Point', 'Intersection', 'Corridor'],
        datasets: [
          {
            backgroundColor: [this.locationTypesColors.point, this.locationTypesColors.intersection, this.locationTypesColors.corridor],
            data: [parseInt(this.statsLocationTypes.point), parseInt(this.statsLocationTypes.intersection), parseInt(this.statsLocationTypes.corridor)],
          }
        ]
      };
    },
    timeline () {
      let results = {}
      for (let i in this.conditionsPhotosDateAsc) {
        let dateStamp = this.conditionsPhotosDateAsc[i].createdAt.substr(0,10)
        if (!results[dateStamp]) {
          results[dateStamp] = 1
        }
        results[dateStamp]++
      }
      console.log("TCL: timeline -> results", results)
      return results
    },
    timelineLabels () {
      let keys = Object.keys(this.timeline)
      return keys.filter((x, i) => (i === 0 || i === keys.length-1))
                .map(x => {
                  let dt = new Date(x);
                  return monthNames[dt.getMonth()].substr(0,3).toUpperCase() + ' ' + (dt.getFullYear()+'').substr(2,2)
                });
    },
    dateRange () {
      if (this.conditionsPhotosDateAsc.length > 1) {
        return this.conditionsPhotosDateAsc[0].createdAt.substr(0,10) + " and " + this.conditionsPhotosDateAsc[this.conditionsPhotosDateAsc.length-1].createdAt.substr(0,10)
      }
      return ''
    }
  },
  methods: {
    initMap () {
      if (map) {
        return
      }
      map = L.map('admin-map') //.setView(this.startLatLng, this.startZoom);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: 'Tiles courtesy of <a href="http://openstreetmap.se/" target="_blank">OpenStreetMap Sweden</a> &mdash; Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(map);
      L.control.scale().addTo(map);
       map.setView(this.startLatLng, 14);
    },
    scrollConditionsToTop () {
      document.getElementById('conditions-list').scrollTop = 0
    },
    viewConditionDetails (conditionObj) {
      map.setView([conditionObj.lat, conditionObj.lng], 16);
      let marker = markers.find(m => m.cid === conditionObj.id)
      marker.fire('click');
    },
    addConditionsToMap () {
      function setColor (obType) {
        return observationsColors[obType.toLowerCase()]
      }
      this.conditionsPhotosList.forEach(c => {
        let latLng = [parseFloat(c.lat), parseFloat(c.lng)]
        let marker = new L.CircleMarker(latLng, {
            radius: 6,
            fillColor: setColor(c.observation),
            color: "#111",
            weight: 1,
            opacity: 1,
            fillOpacity: 0.9,
            title: "test"
        })
        .addTo(map)
        .on("click", (e) => {
          let content = `
          <div style="font-size:1.1em;min-width: 350px; ">
            <div class="map-popup-label">Observation:</div> <strong>${c.observation}</strong><br>
            <div class="map-popup-label">Location Type:</div> <strong>${c.location_type}</strong><br>
            ${(c.condition_type) ? '<div class="map-popup-label">Condition Type:</div> <strong>' + c.condition_type + '</strong>' : ''}
          </div>
            <div style="color: #777; margin-top: 6px;">${c.createdAt.substr(0,16).split("T").join(" ")}</div>
            <div style="margin-top: 5px; font-style: italic;">&quot;${c.description}&quot;</div>
          <br><br>`
          if (c.photos.length) {
            c.photos.forEach(p => {
              content += `<img class="photo-thumb" src="${apiBaseUrl + '/uploads/thumbs/' + p.filename}" onclick="window.open('${apiBaseUrl + '/uploads/' + p.filename}')">`
            })
          }
          e.target.bindPopup(`<div style="min-width: 350px; min-height: 150px; padding: 10px;">${content}</div>`).openPopup()
        });
        marker.cid = c.id
        markers.push(marker)
      })
    },
    openImgUrl (imgUrl) {
      window.open(imgUrl)
    },
    downloadConditions () {
      location.href = apiBaseUrl + "/admin/download/conditions"
    },
    downloadPhotosCSV () {
      location.href = apiBaseUrl + "/admin/download/photos"
    },
    downloadPhotosFiles () {
      location.href = apiBaseUrl + "/admin/download/photofiles"
    },
    openConditionDetails (condition) {
      this.conditionDetailsDialog = true
      this.conditionDetailsData = condition
    },
    async getUserTotal () {

    },
    async fetchConditionsPhotos () {
      // this.recordingStatus = 'pending'
      let conditions = await this.$httpApi.get('/conditions?showall=1')
      let photos = await this.$httpApi.get('/photos?showall=1')
      let userIds = {}
      conditions.data.forEach(x => userIds[x.user_id] = 1)
      this.totalUsers = Object.keys(userIds).length
      this.totalPhotos = photos.data.length
      this.conditionsPhotosList = conditions.data.map(condition => {
        condition.photos = photos.data.filter(x => x.condition_id === condition.id)
        return condition
      })
      setTimeout(() => this.addConditionsToMap(), 1000)

    },
  },
  beforeMount () {
    this.getUserTotal()
    this.fetchConditionsPhotos()
  },
  mounted () {
    setTimeout(() => this.initMap(), 100)

  }
}
</script>

<style lang="scss" scoped>
.v-card__title {
  // font-weight: bold;
  font-size: 1.1em;
}
.figure {
  font-family: Roboto;
  font-size: 2.5em;
  text-align: center;
  font-weight: bold;
  color: #333;
}

.figure-label {
  text-transform: capitalize;
  font-family: Roboto;
  font-size: .9em;
  text-align: center;
  color: #777;
}
</style>


<style>
@import url('https://unpkg.com/leaflet@1.5.1/dist/leaflet.css');

#admin-map {
  background-color: #F2EFE9;
  border:solid 1px #999;
  /* position: absolute;
  top: 0;
  bottom: 0;
  left:0;
  right: 0; */
  z-index: 98;
  /* min-height: 250px; */
  /* height: 100%; */
  /* height: calc(100% - 50px); */
}
#admin-map-key {
  z-index: 99;
  position: absolute;
  top: calc(15vh + 20px);
  right:25px;
  border:solid 1px #999;
  padding: 6px;
  font-size:.9em;
  background-color: rgba(255, 255, 255, 0.9);
}
#admin-map-key ul, li {
  list-style-type: none;
  margin:0;
  padding:0;
}
.mapcircle {
  background-color: #ff7800;
  border-color: black;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  width:5px;
  height:5px;
}
.condition-list-item {
  transition: all .3s;
  background-color: #fff;
  padding: 5px;
  margin: 5px 0;
  cursor: pointer;
}
.condition-list-item:hover {
  background-color: #ddd;
}
.photo-main {
  display:block;
  width: 75%;
  min-width: 400px;
  min-height: 300px;
  border:solid 1px #777;
  margin-top: 10px;
  /* transform: rotate(90deg); */
}

.photo-thumb {
  margin-right: 4px;
  width: 200px;
  height: 200px;
  border:solid 1px #777;
  transition: all .3s;
}
.photo-thumb:hover {
  border:solid 1px #ff33ff;
  cursor: pointer;
}
.v-card__title {
  font-weight: bold;
}

.map-popup-label {
  display: inline-block;
  width: 100px;
}
.leaflet-popup-content-wrapper {
  min-width: 420px;
}
</style>